import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { WorkOrderFindingsFields } from './WorkOrderFindingsFields';
import { toast } from 'sonner';

export const AddWorkOrderFindingsDialog = ({ workOrderId, title, onClose, onSaved }) => {
  const [findings, setFindings] = useState([]);
  const [saving, setSaving] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.post(`${API}/work-orders/${workOrderId}/findings`, { findings });
      toast.success('Findings saved · original completion date unchanged');
      window.dispatchEvent(new Event('maintenance-records-changed'));
      onSaved?.();
      onClose();
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Check each finding and try again.');
    } finally { setSaving(false); }
  };
  return <Dialog open onOpenChange={(open) => { if (!open && !saving) onClose(); }}>
    <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="add-wo-findings-dialog">
      <DialogHeader><DialogTitle>Add service findings</DialogTitle><DialogDescription>{title}</DialogDescription></DialogHeader>
      <form onSubmit={save} className="space-y-4">
        <WorkOrderFindingsFields value={findings} onChange={setFindings} disabled={saving} />
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" disabled={saving} onClick={onClose} data-testid="add-findings-cancel">Cancel</Button>
          <Button type="submit" disabled={saving || !findings.length} data-testid="add-findings-submit">{saving ? 'Saving…' : 'Save findings'}</Button>
        </div>
      </form>
    </DialogContent>
  </Dialog>;
};